var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDownloadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15423 10.4527V3.51761C7.15423 3.27799 7.23528 3.07713 7.39738 2.91503C7.55948 2.75293 7.76035 2.67188 7.99997 2.67188C8.2396 2.67188 8.44046 2.75293 8.60256 2.91503C8.76466 3.07713 8.84571 3.27799 8.84571 3.51761V10.4527L11.2984 8.00004C11.4534 7.84498 11.6508 7.76746 11.8904 7.76746C12.13 7.76746 12.3273 7.84498 12.4824 8.00004C12.6374 8.15509 12.715 8.35243 12.715 8.59205C12.715 8.83168 12.6374 9.02902 12.4824 9.18407L8.59199 13.0745C8.42284 13.2436 8.2255 13.3282 7.99997 13.3282C7.77444 13.3282 7.5771 13.2436 7.40796 13.0745L3.51755 9.18407C3.3625 9.02902 3.28497 8.83168 3.28497 8.59205C3.28497 8.35243 3.3625 8.15509 3.51755 8.00004C3.6726 7.84498 3.86994 7.76746 4.10957 7.76746C4.3492 7.76746 4.54654 7.84498 4.70159 8.00004L7.15423 10.4527Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadArrow);
export default __webpack_public_path__ + "static/media/ic_download_arrow.6aaf595e7de996e322d71fc5da922acc.svg";
export { ForwardRef as ReactComponent };